import { render, staticRenderFns } from "./sort-dialog.vue?vue&type=template&id=c02c0a44&scoped=true"
import script from "./sort-dialog.vue?vue&type=script&lang=js"
export * from "./sort-dialog.vue?vue&type=script&lang=js"
import style0 from "./sort-dialog.vue?vue&type=style&index=0&id=c02c0a44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02c0a44",
  null
  
)

export default component.exports